import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@/lib/utils';
import { circleShape, pillShape } from '@/lib/shapeStyles';

const Slider = React.forwardRef<
	React.ElementRef<typeof SliderPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, value, defaultValue, ...props }, ref) => {
	// Determine how many thumbs to render based on value/defaultValue
	const thumbCount = Array.isArray(value)
		? value.length
		: Array.isArray(defaultValue)
			? defaultValue.length
			: 1;

	return (
		<SliderPrimitive.Root
			ref={ref}
			className={cn('relative flex w-full touch-none select-none items-center', className)}
			value={value}
			defaultValue={defaultValue}
			{...props}
		>
			<SliderPrimitive.Track
				className={cn('relative h-2 w-full grow overflow-hidden bg-white/5', pillShape)}
			>
				<SliderPrimitive.Range className="absolute h-full bg-active-gold" />
			</SliderPrimitive.Track>
			{Array.from({ length: thumbCount }).map((_, index) => (
				<SliderPrimitive.Thumb
					key={index}
					className={cn(
						'block h-5 w-5 border-2 border-active-gold bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-active-gold/60 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-pointer',

						circleShape
					)}
				/>
			))}

		</SliderPrimitive.Root>
	);
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
